function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M90.888 9.9748L91.0935 9.948L91.2933 9.89321L108.212 5.25429C114.515 3.52596 121.056 7.09378 123.016 13.3291L123.259 14.1034C123.69 15.4755 123.781 16.9319 123.524 18.3469L122.819 22.2258C122.217 25.5346 118.807 27.5277 115.629 26.4276C112.492 25.3418 109.039 25.6662 106.16 27.3171L76.378 44.3919C75.0349 45.1619 73.3377 44.9013 72.2876 43.7636C69.9443 41.225 66.3889 40.191 63.0496 41.0769L44.4293 46.017C43.2208 46.3376 41.9757 46.5 40.7253 46.5H23.2354C20.5333 46.5 18.7759 43.6564 19.9843 41.2396C22.7409 35.7264 19.6833 29.0785 13.7034 27.5835L9.42669 26.5143C6.94039 25.8928 4.97479 23.9916 4.27073 21.5274L3.70276 19.5395C2.05928 13.7873 5.42757 7.79994 11.197 6.21801L18.4282 4.23524C24.0194 2.70219 30.0064 3.92938 34.5435 7.53846L36.7148 9.26562C44.6291 15.5611 55.2075 17.386 64.7737 14.1062L65.7569 13.7691C67.3731 13.2149 69.0409 12.8244 70.7352 12.6034L90.888 9.9748Z",
  stroke: "currentColor",
  strokeWidth: 6
});

function SvgCountryside4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 50,
    viewBox: "0 0 127 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryside4);
export default __webpack_public_path__ + "static/media/countryside4.d53bd18e.svg";
export { ForwardRef as ReactComponent };